import Marquee from "react-fast-marquee";

const ITEMS = [
  "Website Issue Report",
  "ADA Compliance",
  "WCAG 2.1",
  "Accessibility First",
  "3 Business Days",
  "$99 Flat",
];

export const MarqueeStrip = ({ className = "" }) => (
  <div
    data-testid="editorial-marquee"
    className={`overflow-hidden border-y border-slate-200 bg-slate-50 py-5 ${className}`}
  >
    <Marquee speed={30} gradient={false} pauseOnHover>
      {ITEMS.concat(ITEMS).map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="whitespace-nowrap px-8 font-serif text-2xl italic tracking-tight text-slate-400 md:text-3xl">
            {item}
          </span>
          <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-blue-600/50" />
        </span>
      ))}
    </Marquee>
  </div>
);
